import type * as React from 'react';
import { Button } from '@verclam/ui-kit';
import { SlidersHorizontal } from 'lucide-react';

type Props = {
	readonly panelId: string;
	readonly isOpen: boolean;
	/** Number of active criteria; `0` hides the badge. */
	readonly activeCount: number;
	readonly onClick: () => void;
};

/** Button opening the filter sidebar. Renders the bare button: layout belongs to the page. */
const FilterPanelTrigger: React.FC<Props> = ({ panelId, isOpen, activeCount, onClick }) => {
	const badgeProps = activeCount > 0 ? { badge: String(activeCount) } : {};

	return (
		<Button
			type="button"
			label="Filtres"
			icon={<SlidersHorizontal size={16} />}
			outlined
			{...badgeProps}
			aria-expanded={isOpen}
			aria-controls={panelId}
			onClick={onClick}
		/>
	);
};

export default FilterPanelTrigger;
